import React from 'react';
import styles from './AgreementTableLine.module.scss';
import sizes from '../agreements-table-sizes.module.scss';
import moment from 'moment';
import { Tag } from 'components';
import StatusHandler from './StatusHandler';
import { inject } from 'mobx-react';
import { GENERAL_STORE } from 'store';
import { AgreementTableLineProps } from './types';
import { getBrandNames, getRemainingBudget } from './utils';

const AgreementTableLine = (props: AgreementTableLineProps) => {
  const { agreement, [GENERAL_STORE]: { push } } = props;

  return (
    <div className={styles.tableRow}>
      <h4 onClick={() => push(`/agreements/edit/${agreement.id}`)}>
        {agreement.name}
      </h4>
      <div style={{ width: sizes.brandWidth }}>
        {getBrandNames(agreement)}
      </div>
      <div style={{ width: sizes.budgetWidth }}>
        {agreement.budget}
      </div>
      <div style={{ width: sizes.budgetRemainingWidth }}>
        {getRemainingBudget(agreement)}
      </div>
      <div style={{ width: sizes.dateStartWidth }}>
        {moment(agreement.startDate).format('DD.MM.YYYY')}
      </div>
      <div style={{ width: sizes.dateEndWidth }}>
        {moment(agreement.endDate).format('DD.MM.YYYY')}
      </div>
      <div style={{ width: sizes.scopesWidth }}>
        {agreement.scopes && agreement.scopes.map(scope =>
          <Tag key={scope.id} tag={scope.name} />
        )}
      </div>
      <StatusHandler agreement={agreement} />
    </div>
  );
};

export default inject(GENERAL_STORE)(AgreementTableLine);